<template>
  <div>
    <template v-if="loading || loadingInfos">
      <opq-loading>{{ loadingMessage }}</opq-loading>
    </template>
    <template v-else>
      <div class="mb-6">
        <h1 class="display-1 mb-3"><ressource code="titre-etape-1" /></h1>
        <v-divider class="my-3"></v-divider>
        <ressource code="sous-titre-etape-1" hide-if-empty />
      </div>
      <v-form ref="mainForm">
        <v-row v-for="(item) in sas.emploisReferences" :key="item.emploiReference" align="center">
          <v-col cols="12">
            <v-checkbox
              class="list_counter_validator my-4 p-0"
              :input-value="hasDisponibiliteSelected(item)"
              :rules="[(v) => !!v || 'Veuillez sélectionner une option.']"
            ></v-checkbox>
          </v-col>
          <v-col cols="3" class="pa-3">
            <h3>{{ item.raisonSociale }}</h3>
            <p class="my-0">{{ item.adresse }}</p>
            <p class="my-0">{{ item.ville }}</p>
            <p class="my-0">Disponibilité : {{ item.disponibiliteActuelle }}</p>
          </v-col>
          <v-col cols="9" class="pa-0">
            <v-row>
              <v-col cols="3" class="pa-3">
                <opq-case
                  code="service-reference-disponibilite0_3Mois"
                  v-model="item.nouvelleDisponibilite0_3Mois"
                  @input="nouvelleDisponibilite0_3MoisSelected(item)"
                  :optional="true"
                ></opq-case>
              </v-col>
              <v-col cols="3" class="pa-3">
                <opq-case
                  code="service-reference-disponibilite3_6Mois"
                  v-model="item.nouvelleDisponibilite3_6Mois"
                  @input="nouvelleDisponibilite3_6MoisSelected(item)"
                  :optional="true"
                ></opq-case>
              </v-col>
              <v-col cols="3" class="pa-3">
                <opq-case
                  code="service-reference-disponibilite6MoisPlus"
                  v-model="item.nouvelleDisponibilite6MoisPlus"
                  @input="nouvelleDisponibilite6MoisPlusSelected(item)"
                  :optional="true"
                ></opq-case>
              </v-col>
              <v-col cols="3" class="pa-3">
                <opq-case
                  code="service-reference-suspension"
                  v-model="item.pasDeDisponibilitePourLeMoment"
                  @input="pasDeDisponibilitePourLeMomentSelected(item)"
                  :optional="true"
                ></opq-case>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12"><v-divider></v-divider></v-col>
        </v-row>

          <div class="mt-6">
            <v-btn color="#3a3838" dark large class="my-3" @click="submit" :disabled="loading" :loading="loading">Soumettre</v-btn>
          </div>
          <opq-alert v-show="showAlert" type="warning" class="mt-6" code="formulaire-incomplet" width="700"></opq-alert>

      </v-form>
    </template>
  </div>
</template>

<script>

import FormulaireBase from "@/mixins/FormulaireBase"
import CataloguesHelpers from "@/mixins/CataloguesHelpers"
import { Api } from "@/plugins/api"

export default {
  mixins: [FormulaireBase, CataloguesHelpers],
  data() {
    return {
      paramsName: "courriel-formulaire-sref",
      loadingInfos: true,
      loadingMessage: this.$t("formulaires.chargement"),
      endpoint: "/mise-a-jour-service-reference",
      sas: { emploisReferences : [] },
      showAlert: false,
    }
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  },

  mounted() {
    this.loadParams(this.paramsName)

    this.loadingInfos = true
    this.hasAccess()
      .then((access) => {
        if (!access) {
          return
        }
        this.getEmploisReferences()
          .then(() => {
            this.loadingInfos = false
          })
      })
  },

  methods: {
    async hasAccess() {
      return Api.get(this.endpoint + "/has-access?token=" + this.token)
        .then((res) => {
          if (!res.data) {
             this.$router.push({
              name: "Unauthorized",
            })
            return false
          }
          return true
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
            })
          } else if (error.response.status === 401) {
            this.$router.push({
              name: "Unauthorized",
            })
          } else {
            this.$router.push({
              name: "InternalError",
            })
          }
          return false
        })
    },
    async getEmploisReferences()
    {
      return Api.get(this.endpoint + "/get-emplois-references?token=" + this.token)
        .then((res) => {
          if(res.data){
            this.sas = res.data
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
            })
          } else if (error.response.status === 401) {
            this.$router.push({
              name: "Unauthorized",
            })
          } else {
            this.$router.push({
              name: "InternalError",
            })
          }
        })
    },

    // Validation : au moins une des disponibilités doit être sélectionnée.
    hasDisponibiliteSelected(item) {

      return (
        item.nouvelleDisponibilite0_3Mois ||
        item.nouvelleDisponibilite3_6Mois ||
        item.nouvelleDisponibilite6MoisPlus ||
        item.pasDeDisponibilitePourLeMoment
      );
    },

    // Les fonctions suivantes assurent que lorsqu'une option de disponibilité est sélectionnée, les autres sont désélectionnées.
    nouvelleDisponibilite0_3MoisSelected(item) {

      if(!item.nouvelleDisponibilite0_3Mois){
        return;
      }

      item.nouvelleDisponibilite3_6Mois = false;
      item.nouvelleDisponibilite6MoisPlus = false;
      item.pasDeDisponibilitePourLeMoment = false;
    },
    
    nouvelleDisponibilite3_6MoisSelected(item) {

      if(!item.nouvelleDisponibilite3_6Mois){
        return;
      }

      item.nouvelleDisponibilite0_3Mois = false;
      item.nouvelleDisponibilite6MoisPlus = false;
      item.pasDeDisponibilitePourLeMoment = false;
    },

    nouvelleDisponibilite6MoisPlusSelected(item) {

      if(!item.nouvelleDisponibilite6MoisPlus){
        return;
      }

      item.nouvelleDisponibilite0_3Mois = false;
      item.nouvelleDisponibilite3_6Mois = false;
      item.pasDeDisponibilitePourLeMoment = false;
    },

    pasDeDisponibilitePourLeMomentSelected(item) {

      if(!item.pasDeDisponibilitePourLeMoment){
        return;
      }

      item.nouvelleDisponibilite0_3Mois = false;
      item.nouvelleDisponibilite3_6Mois = false;
      item.nouvelleDisponibilite6MoisPlus = false;
    },

    submit() {
      if (this.$refs.mainForm.validate()) {
        this.loading = true
        this.loadingMessage = this.$t("formulaires.envoiDesInformations")

        this.soumissionSas()
      } else {
        this.showAlert = true
      }
    },

    soumissionSas() {
        Api.post(this.endpoint + "/submit?token=" + this.token, this.sas)
          .then((res) => {
            if (res.data.traite) {
              this.$router.push({
                name: "FormulaireTraite",
              })
            } else {
              this.$router.push({
                name: "FormulaireSoumis"
              })
            }
          })
          .finally(() => {
            this.loading = false
          })
    },
  },

  computed:{    
    token() {
      const token = this.$route.query.token
      return token
    },
  },
}
</script>

<style>
</style>